import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Withdraw() {
  const [funds, setFunds] = useState([]);
  const [processingFunds, setProcessingFunds] = useState({});

  const fetchFunds = async () => {
    try {
      const res = await axios.get(
        "https://api.earnmoney0.top/admin/pending-withdraws",
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (res.data.success) setFunds(res.data.funds || []);
    } catch (err) {
      console.error("❌ Fetch Pending Withdraws Error:", err);
    }
  };

  useEffect(() => {
    fetchFunds();
  }, []);

  const handleFundStatus = async (fundId, status) => {
    if (processingFunds[fundId]) return;

    try {
      setProcessingFunds((prev) => ({ ...prev, [fundId]: true }));
      const res = await axios.put(
        `https://api.earnmoney0.top/admin/withdraw-status/${fundId}`,
        { status },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (res.data.success) {
        setFunds((prev) => prev.filter((f) => f._id !== fundId));
        showToast(`Withdraw ${status} Successfully`, status === "Approved");
      }
    } catch (err) {
      console.error("❌ Withdraw Status Update Error:", err);
      alert("⚠️ Failed to update withdraw status");
    } finally {
      setProcessingFunds((prev) => ({ ...prev, [fundId]: false }));
    }
  };

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    showToast("Copied to clipboard", true);
  };

  const showToast = (text, success = true) => {
    const msg = document.createElement("div");
    msg.textContent = text;
    msg.style.position = "fixed";
    msg.style.top = "20px";
    msg.style.right = "20px";
    msg.style.background = success
      ? "linear-gradient(90deg,#00ff88,#00c46a)"
      : "linear-gradient(90deg,#ff5252,#d32f2f)";
    msg.style.color = "#fff";
    msg.style.fontWeight = "600";
    msg.style.padding = "10px 18px";
    msg.style.borderRadius = "8px";
    msg.style.zIndex = "9999";
    msg.style.boxShadow = "0 0 15px rgba(0,0,0,.4)";
    document.body.appendChild(msg);
    setTimeout(() => msg.remove(), 2200);
  };

  return (
    <div
      style={{
        padding: 20,
        color: "#fff",
        backgroundColor: "#0f172a",
        minHeight: "100vh",
      }}
    >
      <h2 style={{ fontSize: 24, marginBottom: 20, color: "#f2a900" }}>
        💸 Withdraw Requests
      </h2>

      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 12px",
        }}
      >
        <thead style={{ backgroundColor: "#111827", color: "#f2a900" }}>
          <tr>
            <th>Username</th>
            <th>Phone</th>
            <th>Method</th>
            <th>Number</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {funds.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center", padding: 12 }}>
                No pending withdraw requests
              </td>
            </tr>
          ) : (
            funds.map((fund) => (
              <tr
                key={fund._id}
                style={{
                  backgroundColor: "#020617",
                  borderRadius: "12px",
                  padding: 8,
                }}
              >
                {/* Username */}
                <td style={{ padding: "12px" }}>
                  {fund.userId?.name || "Unknown"}
                </td>

                {/* Phone */}
                <td style={{ padding: "12px", fontSize: 12, color: "#ccc" }}>
                  {fund.userId?.phone || "N/A"}
                </td>

                {/* Method */}
                <td style={{ padding: "12px" }}>{fund.method}</td>

                {/* Number with copy */}
                <td style={{ padding: "12px", color: "#00eaff", fontWeight: 600 }}>
                  {fund.number}
                  <span
                    onClick={() => copyText(fund.number)}
                    style={{ marginLeft: 6, cursor: "pointer", color: "#22c55e" }}
                    title="Copy Number"
                  >
                    📋
                  </span>
                </td>

                {/* Amount */}
                <td style={{ padding: "12px", color: "#22c55e", fontWeight: 600 }}>
                  ৳{fund.amount}
                </td>

                {/* Date */}
                <td style={{ padding: "12px", color: "#ccc" }}>
                  {fund.createdAt ? new Date(fund.createdAt).toLocaleString() : "—"}
                </td>

                {/* Status */}
                <td style={{ padding: "12px" }}>
                  <span
                    style={{
                      backgroundColor: "#facc15",
                      color: "#000",
                      padding: "4px 10px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {fund.status}
                  </span>
                </td>

                {/* Action */}
                <td style={{ padding: "12px", display: "flex", gap: 10, justifyContent: "center" }}>
  <button
    onClick={() => handleFundStatus(fund._id, "Approved")}
    disabled={processingFunds[fund._id]}
    style={{
      backgroundColor: "#22c55e",
      padding: "4px 10px",
      borderRadius: 6,
      cursor: processingFunds[fund._id] ? "not-allowed" : "pointer",
    }}
  >
    {processingFunds[fund._id] ? "Processing..." : "✅ Approve"}
  </button>

  <button
    onClick={() => handleFundStatus(fund._id, "Rejected")}
    disabled={processingFunds[fund._id]}
    style={{
      backgroundColor: "#ef4444",
      color: "#fff",
      padding: "4px 10px",
      borderRadius: 6,
      cursor: processingFunds[fund._id] ? "not-allowed" : "pointer",
    }}
  >
    {processingFunds[fund._id] ? "Processing..." : "❌ Cancel"}
  </button>
</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}